import getEntityTypeName from '../view/getEntityTypeName';
import CardItem from 'txp-data/lib/schema/viewSchema/CardItem';
import { OWA } from '../../helpers/TxpConstants';
import EntityType from 'txp-data/lib/schema/innerSchema/EntityType';
import PostalAddress from 'txp-data/lib/schema/innerSchema/PostalAddress';
import {
    reservationForNamePath,
    lodgingStreetAdressPath,
    serviceReservationStreetAdressPath,
    serviceReservationPostalCodePath,
    serviceReservationAddressLocalityPath,
    serviceReservationAddressRegionPath,
    serviceReservationAddressCountryPath,
} from '../../helpers/EditableCardConsts';

export interface EditableRequestBody {
    inferenceId: string;
    entityType: string;
    editData: any[];
    source: string;
}

/**
 * Returns the request body for GWS API save editable event for only the valid fields
 * When both fields are null we shouldn't generate request body
 */
export default function getSaveEditableRequestBody(
    cardItem: CardItem,
    reservationForName?: string,
    location?: PostalAddress
): EditableRequestBody | null {
    let editData = [];
    if (reservationForName != null) {
        editData.push({
            path: reservationForNamePath,
            value: reservationForName,
        });
    }
    if (location) {
        switch (cardItem.entityType) {
            case EntityType.LodgingReservation:
                editData.push({
                    path: lodgingStreetAdressPath,
                    value: location.displayAddress,
                });
                break;
            case EntityType.ServiceReservation:
                editData.push(
                    {
                        path: serviceReservationStreetAdressPath,
                        value: location.streetAddress,
                    },
                    {
                        path: serviceReservationPostalCodePath,
                        value: location.postalCode || '',
                    },
                    {
                        path: serviceReservationAddressLocalityPath,
                        value: location.addressLocality || '',
                    },
                    {
                        path: serviceReservationAddressRegionPath,
                        value: location.addressRegion || '',
                    },
                    {
                        path: serviceReservationAddressCountryPath,
                        value: location.addressCountry || '',
                    }
                );
                break;
            default:
                break;
        }
    }

    if (editData.length > 0) {
        return {
            inferenceId: cardItem.inferenceId,
            entityType: getEntityTypeName(cardItem.entityType),
            editData: editData,
            source: OWA,
        };
    }
    return null;
}
